import { Directive } from "@angular/core";
import { GridBase } from "./grid.base";
import { ResultsService } from "./results.service";

@Directive()
export abstract class ResultsGridBase extends GridBase {

    constructor(protected service: ResultsService) {
        super();
    }

    /**
     * Recalculates the results by id
     * @param id the id of the desired results to recalculate
     */
    protected recalculateResults(id: number): void {
        this.service.recalculateResults(id).subscribe(() => {
        /** shows success snackbar when results were recalculated */
        this.snackBar.success(this.translate.instant('ResultsRecalculated'));

        /** reloads grid with fresh data */
        this.reload();
        })
    }

    /**
     * Obtains display results status
     */
    protected loadDisplayResultsStatus(id: number, initialLoad = false): void {
        this.sub.add(this.service.getDisplayResultsStatus(id).subscribe((display: boolean) => {
        /** notifies user about display property change */
        if (!initialLoad) {
            this.snackBar.success(this.translate.instant(display ? 'ResultsDisplaySuccess' : 'ResultsHideSuccess'));
        }
        /** sets display property according to API change */
        this.display.set(display);
        }));
    }



    /**
     * Updates the display results status
     */
    protected updateDisplayStatus(id: number): void {
        this.sub.add(this.service.updateResultsStatus(id).subscribe(() => {
        /** loads the display results status */
        this.loadDisplayResultsStatus(id);
        }));
    }
}